import { render, staticRenderFns } from "./PostDetail.vue?vue&type=template&id=adac6596&scoped=true&"
import script from "./PostDetail.vue?vue&type=script&lang=js&"
export * from "./PostDetail.vue?vue&type=script&lang=js&"
import style0 from "./PostDetail.vue?vue&type=style&index=0&id=adac6596&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adac6596",
  null
  
)

export default component.exports